var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{attrs:{"src":"https://metabase.carnegosystems.net/public/question/1543b265-8ac3-4b87-ae2a-aac0e064fab6","frameborder":"0","width":"1200","height":"800","allowtransparency":""}})}
var staticRenderFns = []

export { render, staticRenderFns }